import { safeDefine } from "@breuni-ui/safe-define";
import { CarouselNavigationNext } from "@breuni-ui/carousel";

export default class EntdCarouselNaviNext extends CarouselNavigationNext {}
safeDefine("entd-carousel-navi-next", EntdCarouselNaviNext);
